<template>
  <div>
    <div id="formTable" v-if="false">
      <div class="formTableItem">
        <Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="400"
    >
      <template slot-scope="{ row, index }" slot="imgPath2">
        <viewer v-if="row.imgPath != null && row.imgPath.length > 0">
          <img
            v-for="(x, index) in row.imgPath2"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>

    <form-model
      :title="isAdd ? '新增跟进记录' : '编辑跟进记录'"
      width="700"
      ref="formModel"
      :labelWidth="110"
    >
      <FormItem slot="form" slot-scope="{ row }" label="名称" prop="name">
      </FormItem>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        oid: 0,
        groupId: "",
        groupName: "",
        remark: "", //跟进说明
        contact: "", //联系人
        imgPath: "",
        imgPath2: [],
        status: 0, //状态(初步洽谈-0|重点跟进-1|成单-2|放弃-3|关注状态-4|意向客户-5)
        nextTime: Date.now() + 86400000 * 15, //下次跟进时间
      },
      //状态(初步洽谈-0|重点跟进-1|成单-2|放弃-3|关注状态-4|意向客户-5)
      forms: [
        /* {
          title: "跟进状态",
          key: "status",
          type: "Select1",
          st:'selfStatus',
          required: true,
        }, */
        {
          title: "下次跟进时间",
          key: "nextTime",
          key2: "nextTime2",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "当前状态",
          key: "status",
          key2: "status2",
          noTable: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["cusStatus"],
          required: true,
        },
        {
          title: "附件",
          key: "imgPath2",
          slot: "imgPath2",
          type: "lyPhoto",
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
          required: true,
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
    };
  },
  methods: {
    reach(v) {
      this.item.oid = v.id;
      this.searchItem.oid = v.id;
      this.item.groupId = v.groupId;
      this.item.contact = v.contact;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/ordersVisit/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].nextTime2 = this.utils.time(data[i].nextTime, "yymmdd");
          data[i].imgPath2 = this.utils.strToJson(data[i].imgPath);
          
          data[i].status2=this.lydic.getVal('cusStatus',data[i].status);
        }
        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.imgPath = this.utils.jsonToStr(a.imgPath2);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/ordersVisit/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/ordersVisit/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-smm/ordersVisit/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    reachAdd(v){
      this.item.oid = v.id;
      this.searchItem.oid = v.id;
      this.openAdd();
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    cols() {
      var b = JSON.parse(JSON.stringify(this.forms));
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        if (!b[i].minWidth && !b[i].maxWidth) {
          b[i].minWidth = 200;
          b[i].maxWidth = 300;
        }
        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }
      this.columns.splice(1, 0, ...b);
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
  },
  mounted() {
    this.cols();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/xiaoshou/baifangjilu.vue